const clearBadgeUrl = () => document.querySelector("meta[name='notification-badge-clear-url']")?.content

const csrfToken = () => document.querySelector("meta[name='csrf-token']")?.content

const jsonHeaders = () => {
  const headers = { Accept: "application/json" }
  const token = csrfToken()
  if (token) headers["X-CSRF-Token"] = token

  return headers
}

const clearBrowserBadge = () => {
  if (!("clearAppBadge" in navigator)) return Promise.resolve()

  return navigator.clearAppBadge().catch(() => {})
}

const clearServerBadge = (url) => fetch(url, {
  credentials: "same-origin",
  headers: jsonHeaders(),
  method: "DELETE"
}).catch(() => {})

const clearNotificationBadge = () => {
  const url = clearBadgeUrl()
  if (!url) return

  clearBrowserBadge()
  clearServerBadge(url)
}

document.addEventListener("turbo:load", clearNotificationBadge)
